export default __webpack_public_path__ + "static/media/pivotMinimise.1be92dca.svg";